export default "/_next/static/images/prefill-empty-50a5d252fdaeaee4a19d84d0958cfe04.png";